// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import 'jquery'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Button, Select, Input, InputNumber, Dialog, Message, Pagination } from 'element-ui';

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.prototype.axios = axios
Vue.component(Pagination.name, Pagination)
Vue.component(Button.name, Button).component(Select.name, Select).component(Input.name, Input).component(InputNumber.name, InputNumber).component(Dialog.name, Dialog).component(Message.name, Message);


import './styles/style.css'
import './styles/bootstrap.css'
import './styles/sell.css'

const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'zh',
  // 从localStorage里获取用户中英文选择，没有则默认中文
  messages: {
    'zh': require('./components/language/zh'),
    'en': require('./components/language/en')
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js